import isNil from 'lodash/isNil';
import values from 'lodash/values';
import {
  isEmptyString,
} from '@populateui/utils';
import {
  AutoCompleteValue,
} from 'core/components/AutoComplete';

export default function isEmptyAutoCompleteValue<T>(incomingValue: AutoCompleteValue<T>) {
  if (isNil(incomingValue)) {
    return true;
  }

  if (Array.isArray(incomingValue)) {
    return incomingValue.length === 0;
  }

  if (typeof incomingValue === 'object') {
    const objectValues = values(incomingValue);
    return objectValues.length === 0 || objectValues.every((item) => (
      isNil(item) || isEmptyString(String(item))
    ));
  }

  return isEmptyString(String(incomingValue));
}
